"use client";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Card, Chip } from "@mui/material";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { TemplateVariableGroup } from "@/constants/message-template.constants";

type Props = {
  title: string;
  description: string;
  groups: TemplateVariableGroup[];
  onSelect: (variable: string) => void;
};

export function TemplateVariablesBlock({ title, description, groups, onSelect }: Props) {
  return (
    <Card variant="outlined" sx={{ backgroundColor: ({ palette }) => palette.grey[200] }}>
      <Accordion
        disableGutters
        elevation={0}
        sx={{ background: "transparent", "&:before": { display: "none" } }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <MDBox>
            <MDTypography variant="h6">{title}</MDTypography>
            <MDTypography variant="caption" color="text">
              {description}
            </MDTypography>
          </MDBox>
        </AccordionSummary>

        <AccordionDetails>
          {groups.map((group) => (
            <MDBox key={group.title} mb={2}>
              <MDTypography
                variant="caption"
                fontWeight="bold"
                color="text"
                textTransform="uppercase"
              >
                {group.title}
              </MDTypography>
              <MDBox mt={0.5} display="flex" flexWrap="wrap" gap={0.5}>
                {group.variables.map((variable) => (
                  <Chip
                    key={variable}
                    label={variable}
                    size="small"
                    variant="outlined"
                    onClick={() => onSelect(variable)}
                    sx={{
                      backgroundColor: ({ palette }) => palette.white.main,
                      borderColor: ({ palette }) => palette.grey[300],
                      "&:hover": {
                        backgroundColor: ({ palette }) => palette.grey[100],
                      },
                    }}
                  />
                ))}
              </MDBox>
            </MDBox>
          ))}
        </AccordionDetails>
      </Accordion>
    </Card>
  );
}
